import type { CaseListItem } from "@/domain/case/case";

/** ホームのカードに出す件数。 */
export type MyCaseSummary = {
  readonly draft: number;
  readonly returned: number;
  readonly inProgress: number;
  readonly completed: number;
};

const EMPTY: MyCaseSummary = {
  draft: 0,
  returned: 0,
  inProgress: 0,
  completed: 0,
};

/**
 * 自分の案件をステータス別に数える。
 *
 * 一覧 API を数え直すのではなく取得済みの結果を集計する（リクエストを増やさない）。
 * 集計対象は取得したページ内の案件なので、件数は「直近分」の目安として扱う。
 */
export function summarizeMyCases(
  items: readonly CaseListItem[],
): MyCaseSummary {
  return items.reduce<MyCaseSummary>((summary, item) => {
    switch (item.status) {
      case "draft":
        return { ...summary, draft: summary.draft + 1 };
      case "returned":
        return { ...summary, returned: summary.returned + 1 };
      case "inProgress":
        return { ...summary, inProgress: summary.inProgress + 1 };
      case "completed":
        return { ...summary, completed: summary.completed + 1 };
      default:
        return summary;
    }
  }, EMPTY);
}
